import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PaycardListModel} from '../../../../shared/services/paycard/paycard.list.model';

@Component({
  selector: 'app-paycards-overview-table',
  templateUrl: './paycards-overview-table.component.html',
  styleUrls: ['./paycards-overview-table.component.scss']
})
export class PaycardsOverviewTableComponent {
  @Input() paycards: PaycardListModel[];

  @Output() openDetails = new EventEmitter<string>();

  constructor() { }

  onOpenDetails(paycardId: string) {
    this.openDetails.emit(paycardId);
  }
}
